import { render, staticRenderFns } from "./ExpensesCreate.vue?vue&type=template&id=fc6a1a02&"
import script from "./ExpensesCreate.vue?vue&type=script&lang=js&"
export * from "./ExpensesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports